export default __webpack_public_path__ + "static/media/together-for-gold-de.791e3731.png";